<ng-template #loading>
    <app-loading></app-loading>
</ng-template>

@if (hasCreatePermissions()) {
<div class="row">
    <div class="col-sm-2 offset-sm-10">
        <a [routerLink]="['/', 'product-create', productType]" class="btn btn-primary">Create New Product</a>
    </div>
</div>
}

@if (allFilters$ | async) {
<div class="m-3">
    <input class="form-control" placeholder="Search {{productName}}" [value]="searchValue"
        (input)="searchInput$.next($any($event.target).value || '')" />
</div>

<div class="d-flex flex-wrap justify-content-center">
    @for (attribute of allFilters.filters; track attribute.key) {
    <div ngbDropdown class="m-1">
        <button type="button" class="btn btn-outline-primary"
            [ngClass]="{ 'btn-primary text-light': hasSelectedFilter(attribute.key) }" ngbDropdownToggle>
            {{attribute.label}}
        </button>
        <div ngbDropdownMenu class="my-dropdown-menu">
            @for (item of getOptionsFor(attribute.key); track item.value) {
            <div class="form-check mx-3">
                <input type="checkbox" class="form-check-input"
                    (change)="updateSelectedFilter(attribute.key, item.value, $event)" [checked]="item.selected"
                    [id]="'filter_check_' + attribute.key + '_' + $index" />
                <label class="form-check-label" [ngClass]="{'text-muted': item.dimmed}"
                    [for]="'filter_check_' + attribute.key + '_' + $index">{{ item.value }}
                    @if(item.count > 0) {
                    <span class="badge rounded-pill bg-secondary" style="font-size: x-small">{{item.count}}</span>
                    }
                </label>
            </div>
            }
        </div>
    </div>
    }
</div>
}

<ng-container *ngIf="products$ | async as products; else loading">
    <div class="container my-4">
        <div class="row g-3">
            @for (product of products.data; track product.id) {
            <div class="col-12">
                <app-product-card [product]="product" [categoryName]="productName"
                    [quoteId]="quoteId"></app-product-card>
            </div>
            }
        </div>
    </div>


    @if (products.pagination.totalPages > 1) {
    <ngb-pagination (pageChange)="updateSearch($event)" [(page)]="page" [maxSize]="10"
        [collectionSize]="products.pagination.totalCount" [pageSize]="products.pagination.pageSize"></ngb-pagination>

    }
</ng-container>